//import { useState, useEffect } from 'react';
import React, { useLayoutEffect, useState,useEffect } from 'react';

import {useDispatch} from 'react-redux';
import {TOGGLE_DARK_MODE } from "./actionTypes";

export const toggleDarkMode = () => ({
  type: TOGGLE_DARK_MODE
});

function useWindowSize() {
    const dispatch = useDispatch()
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  dispatch({ type: 'UPDATE_WINDOW_SIZE', payload: size })
}